import styled, { css } from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';

type SidebarOpenedStyledT = {
  isOpened: boolean;
};

const sidebarIsOpened = css`
  left: 0;
  transition: 0.3s linear;
  animation: slide 0.5s forwards;
  animation-delay: 2s;

  @keyframes slide {
    100% {
      left: 0;
    }
  }
`;

const sidebarIsOpenedContent = css`
  margin-left: 380px;
  ${({ theme }) => `
    ${theme.devices.desktop} {
      transition: 0.3s linear;
    }
  `}
`;

export const LayoutStyled = styled.div`
  display: flex;
`;

export const SidebarWrapStyled = styled.div<SidebarOpenedStyledT>`
  position: fixed;
  left: -350px;
  height: 100vh;
  max-height: 100vh;
  background: ${({ theme }) => theme.colors.primary.variant1};
  transition: left 0.3s linear;
  z-index: 2;

  ${({ isOpened }) => (isOpened ? sidebarIsOpened : '')}
`;

export const ContentWrapStyled = styled.div<SidebarOpenedStyledT>`
  position: relative;
  flex-grow: 1;
  margin-left: 20px;
  overflow-x: hidden;
  transition: 0.3s linear;
  padding-left: 2rem;
  ${({ isOpened }) => (isOpened ? sidebarIsOpenedContent : '')}
`;

export const ButtonCollapseStyled = styled(ButtonIcon)<SidebarOpenedStyledT>`
  position: absolute;
  right: ${({ isOpened }) => (isOpened ? '-15px' : '-38px')};
  top: 40px;
  height: 24px;

  svg {
    transform: rotate(${({ isOpened }) => (isOpened ? '90deg' : '270deg')});
    transition: 0.3s;
  }

  &:hover {
    svg {
      transform: rotate(${({ isOpened }) => (isOpened ? '270deg' : '90deg')});
    }
  }
`;
